import {Component, Input, OnInit} from '@angular/core';
import {SimpleCheckVisit} from "../../models/simple-check-visit.model";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-check-user-visits',
  templateUrl: './check-user-visits.component.html',
  styleUrls: ['./check-user-visits.component.scss'],
})
export class CheckUserVisitsComponent implements OnInit {

  @Input() title;

  @Input()  groupedVisits: { [clinicName: string]: SimpleCheckVisit[] } = {};


  constructor(private modalController: ModalController) {
  }

  ngOnInit(): void {
  }


  onClose() {
    this.modalController.dismiss();
  }

}
